import { reasons } from './VerificationModal';

function RejectReasonsModal({
  onClose,
  onSubmit,
  selectedReasons,
  setSelectedReasons,
  customReason,
  setCustomReason,
}) {
  const toggleReason = (reasonId) => {
    // Only select one reason at a time
    setSelectedReasons([reasonId]);
  };

  const handleSubmit = () => {
    const payload = {
      selectedReasons,
      customReason,
    };
    onSubmit(payload);
    onClose();
  };

  return (
    <>
      <div className="p-24">
        <div
          className="modal-title font-32 fw-medium mb-24"
          style={{ color: "#3E3E3E" }}
        >
          Are you sure to reject this document
        </div>
        <p className="font-20 fw-medium" style={{ color: "#3C4043" }}>
          Document Verification Rejected Reasons
        </p>
        <div className="reasons-list">
          {reasons.map((reason) => (
            <div
              key={reason.id}
              className={`reason-item my-10 ${
                selectedReasons.includes(reason.id) ? "selected" : ""
              }`}
            >
              <label className="w-100">
                <div className="reason-title d-flex justify-content-between align-items-center">
                  <div
                    className="font-20 fw-medium"
                    style={{
                      color: selectedReasons.includes(reason.id)
                        ? "#5E3E05"
                        : "#3C4043", // Active color when selected
                    }}
                  >
                    {reason.title}
                  </div>
                  <input
                    className="form-check-input"
                    style={{ width: "22px", height: "22px" }}
                    type="checkbox"
                    checked={selectedReasons.includes(reason.id)}
                    onChange={() => toggleReason(reason.id)}
                  />
                </div>
                <div
                  className="reason-description font-12"
                  style={{
                    color: selectedReasons.includes(reason.id)
                      ? "#3C4043"
                      : "#3C4043", // Active color when selected
                  }}
                >
                  {reason.description}
                </div>
              </label>
            </div>
          ))}
        </div>
        <div className="other-reason mb-16">
          <label
            className="font-20 fw-medium mb-8"
            style={{ color: "#916008" }}
          >
            Other Reason
          </label>
          <textarea
            className="form-control"
            placeholder="Write Comment"
            value={customReason}
            onChange={(e) => setCustomReason(e.target.value)}
          ></textarea>
        </div>
      </div>
    </>
  );
}

export default RejectReasonsModal;
